import { Routes } from "@angular/router";

// dashboard
import { IndexComponent } from "./index";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";
import { UnauthorizedComponent } from "./unauthorized";
import { realmRoleGuard } from "./core/guards/realm-role.guard";

export const routes: Routes = [
  {
    path: "unauthorized",
    component: AuthLayout,
    children: [
      { path: "", component: UnauthorizedComponent, data: { title: "Unauthorized" } },
    ],
  },
  {
    path: "",
    component: AppLayout,
    canActivateChild: [realmRoleGuard],
    children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      { path: "home", component: IndexComponent, data: { title: "Dashboard" } },
      {
        path: "",
        loadChildren: () =>
          import("./components/components.module").then(
            (d) => d.ComponentsModule
          ),
      },
    ],
  },
  {
    path: "",
    component: AuthLayout,
    children: [],
  },
];
